export default "__VITE_ASSET__ee50cef7__"